module.exports = __webpack_public_path__ + "img/Menu-08.47427399.png";